import React from "react";
import { FieldValues, FormProvider, SubmitHandler, useForm } from "react-hook-form";

import { usePosterReducers } from "@/shared/redux/store/useGetData";

type FormLayoutProps = {
  title?: string;
  children: React.ReactNode;
  submitText?: string;
  defaultValues?: any;
  onSubmit: SubmitHandler<any>;
  height?: string;
};

const FormLayout = ({
  title,
  children,
  submitText = "Submit",
  defaultValues,
  onSubmit,
  height,
}: FormLayoutProps) => {
  const methods = useForm<FieldValues>({
    defaultValues,
  });

  const {
    ui: { formLoading },
  } = usePosterReducers();

  return (
    <FormProvider {...methods}>
      <div className="w-full">
        <div className="w-full">
          {title ? (
            <div className="mb-2">
              <h2 className="text-2xl font-semibold text-gray-800">{title}</h2>
            </div>
          ) : null}

          <form onSubmit={methods.handleSubmit(onSubmit)} className="space-y-5">
            <div className={`overflow-y-auto thin-scrollbar ${height || "max-h-[70vh]"}`}>
              {children}
            </div>

            <div className="flex justify-end">
              <button
                type="submit"
                disabled={formLoading}
                className="flex items-center justify-center gap-2 px-5 py-2 rounded-md bg-theme-primary text-theme-text-inverse hover:bg-theme-primary-hover text-sm font-medium transition-all duration-200 hover:shadow-md cursor-pointer hover:opacity-80 active:scale-95 disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {formLoading ? (
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                ) : null}

                <span>{formLoading ? "Saving..." : submitText}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </FormProvider>
  );
};

export default FormLayout;
